import { createSchema, ZodOutputFor } from "@opstel/query/zod-utils";
import { PlainMessage } from "@bufbuild/protobuf";
import { Location_TrackConnection } from "@opstel/gen/knop/ui/v1/model/location_pb";
import { z } from "zod/v3";
import { pointSchema } from "@opstel/query/models/point";
import { Point } from "@opstel/geo/Point";

export interface TrackConnection {
  code: string;
  coordinate: Point;
  connection0: string;
  connection1: string;
}

export const trackConnectionSchema = createSchema<
  TrackConnection,
  PlainMessage<Location_TrackConnection>
>({
  code: z.string().min(1, "TrackConnection code should not be empty"),
  coordinate: pointSchema,
  connection0: z.string().min(1, "TrackConnection connection0 should not be empty"),
  connection1: z.string().min(1, "TrackConnection connection1 should not be empty"),
}) satisfies ZodOutputFor<TrackConnection>;
